import * as React from 'react';

import SkillSetsTabContent from 'bundles/enterprise-legacy-learner-home/components/single-program/SkillSetsTabContent';
import type ThirdPartyOrganizationsV1 from 'bundles/naptimejs/resources/thirdPartyOrganizations.v1';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/ThirdPartyOrganizationContext';
import { useUserSkillProfile } from 'bundles/unified-home-common/contexts/enterprise/EnterpriseUserSkillProfileContext';

import _t from 'i18n!nls/consumer-home';

const SkillSetsPageNotConfigurable = () => {
  const program = useProgram();
  const thirdPartyOrganization = useThirdPartyOrganization();
  const productFeatures = useEnterpriseProductFeatures();
  const { userSkillProfileStates } = useUserSkillProfile();

  if (!program || !thirdPartyOrganization) {
    return null;
  }

  return (
    <SkillSetsTabContent
      programId={program.id}
      programSlug={program.metadata.slug}
      thirdPartyOrganization={thirdPartyOrganization as ThirdPartyOrganizationsV1}
      userSkillProfileStates={userSkillProfileStates}
      skillSetLength={program.metadata?.linkedTargetSkillProfileIds?.length}
      tutorialVideoAssetId={program.metadata?.tutorialVideoAssetId ?? undefined}
      tutorialVideoUrl={program.metadata?.tutorialVideoUrl ?? undefined}
      showSkillSetRoleFilter={Boolean(productFeatures?.showSkillSetRoleFilter)}
      title={_t('#{programName} Skillsets', { programName: program.metadata.name })}
    />
  );
};

export default SkillSetsPageNotConfigurable;
